<template>
  <div ref="content" class="content">
    <wiki-editor-renderer :editorData="editorData"></wiki-editor-renderer>
  </div>
</template>

<script>
// plugins
// import eventBus from "@/plugins/eventBus";
import WikiEditorRenderer from "@/views/editor/wiki-editor/wiki-editor-renderer.jsx";

export default {
  name: "DetailThridContent",
  components: {
    WikiEditorRenderer
  },
  props: {
    contentData: {
      type: Object,
      default: () => null
    }
  },
  data() {
    return {
      detail: {}
    };
  },
  computed: {
    editorData() {
      const content_json = this.contentData.content_json;
      return content_json ? JSON.parse(content_json) : [];
    }
  },
  created() {
    // 设置内容
    // if (this.contentData && this.contentData.id > 0) {
    //   this.setDetailContent(this.contentData);
    // }
  },
  mounted() {
    // 监听历史记录内容切换
    // eventBus.$on("setDetailContent", this.setDetailContent);
  },
  methods: {
    // 设置内容
    setDetailContent(detail) {
      this.detail = detail;
    }
  }
};
</script>

<style lang="less">
.content {
  // 默认背景颜色
  background-color: #fff;
  // 默认文字颜色
  color: #333;
}
</style>
